import { connect } from "react-redux";
import { injectIntl } from "@ai360/core/intl";
import { computeIsSelectable } from "~/utils/products/use-product-list";
import * as actions from "../actions";
import * as selectors from "../selectors";
import * as blending from "../blending-utils";

import { ProductBlendModal_ } from "../components/product-blend-modal";
import { getSystemPriceExpireDays } from "~/login";

const mapStateToProps = (state) => ({
    allowedMiscellaneousTypes: selectors.getAllowedMiscellaneousTypes(state) || [],
    availableCredits: selectors.getAvailableCredits(state),
    availableProducts: selectors.getAvailableProducts(state),
    batchCreditedRecNutrients: selectors.getBatchCreditedRecNutrients(state),
    carrierProducts: selectors.getCarrierProducts(state),
    creditedGridCells: selectors.getCreditedGridCells(state),
    creditedRecNutrient: selectors.getCreditedRecNutrient(state),
    productBlendGuid: selectors.getProductBlendGuid(state),
    conversionFactors: selectors.getConversionFactors(state),
    customBlends: selectors.getCustomBlends(state),
    customProducts: selectors.getCustomProducts(state),
    defaultCarrierGuid: selectors.getDefaultCarrierGuid(state),
    defaultChemicalTargetRate: selectors.getDefaultChemicalTargetRate(state),
    defaultProductMixTypeGuid: selectors.getDefaultProductMixTypeGuid(state),
    defaultPriceExpireDays: getSystemPriceExpireDays(state),
    filteredProductBlendPicklists: selectors.getFilteredProductBlendPicklists(state),
    filteredProducts: selectors.getFilteredProducts(state),
    isLoading: selectors.getIsLoading(state),
    productBlendPicklists: selectors.getProductBlendPicklists(state),
    productFilters: selectors.getProductFilters(state),
});

const mapDispatchToProps = (dispatch) => ({
    applyCredits: (recNutrientGuid, credits) =>
        dispatch(actions.applyCredits(recNutrientGuid, credits)),
    applyBatchCredits: (recNutrientGuidList, credits) =>
        dispatch(actions.applyBatchCredits(recNutrientGuidList, credits)),
    clearBatchCreditedRecNutrients: () => dispatch(actions.setBatchCreditedRecNutrients(null)),
    clearCreditedRecNutrient: () => dispatch(actions.setCreditedRecNutrient(null)),
    clearCustomBlends: () => dispatch(actions.setCustomBlends([])),
    clearProductBlendGuid: () => dispatch(actions.setProductBlendGuid(null)),
    deactivateProductBlend: (productBlendGuid) =>
        dispatch(actions.deactivateProductBlend(productBlendGuid)),
    fetchAvailableCredits: (recNutrientGuid) =>
        dispatch(actions.fetchAvailableCredits(recNutrientGuid)),
    fetchCreditedGridCells: (recNutrientGuidList) =>
        dispatch(actions.fetchCreditedGridCells(recNutrientGuidList)),
    fetchCustomBlends: (productMixTypeGuid, nutrientGuid) =>
        dispatch(actions.fetchCustomBlends(productMixTypeGuid, nutrientGuid)),
    fetchCustomProducts: () => dispatch(actions.fetchCustomProducts()),
    initProductBlending: (customerGuid) => dispatch(actions.initProductBlendModal(customerGuid)),
    updateProductFilter: (filterProp, filterValue) =>
        dispatch(actions.updateProductFilter(filterProp, filterValue)),
    saveProductBlend: (productBlend, autoUpdate, callback) =>
        dispatch(actions.saveProductBlend(productBlend, autoUpdate, callback)),
    saveCustomProduct: (customProduct) => dispatch(actions.saveCustomProduct(customProduct)),
    setCustomBlends: (customBlends) => dispatch(actions.setCustomBlends(customBlends)),
    setDefaultCarrierGuid: (carrierGuid) => dispatch(actions.setDefaultCarrierGuid(carrierGuid)),
    setDefaultProductMixTypeGuid: (productMixTypeGuid) =>
        dispatch(actions.setDefaultProductMixTypeGuid(productMixTypeGuid)),
    updateBatchRecDetails: (recAreaList) => dispatch(actions.updateBatchRecDetails(recAreaList)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { availableProducts } = stateProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        allowedMiscellaneousTypeRetainPrice: stateProps.allowedMiscellaneousTypes.some(
            (item) => item?.miscellaneousTypeGuid === "77434ba9-35a8-4edf-b095-231d3be7166d"
        ),
        filteredProducts: blending.getFilteredProducts(
            stateProps.filteredProducts,
            ownProps.productMix,
            stateProps.availableProducts
        ),
        filteredNutrientProducts: !ownProps.nutrientGuid
            ? availableProducts
            : availableProducts
                  .filter(
                      (product) =>
                          product.nutrientList &&
                          product.nutrientList.some(
                              (nutrient) => nutrient.nutrientGuid === ownProps.nutrientGuid
                          )
                  )
                  .map((product) => ({
                      activeYn: product.activeYn,
                      isSelectable: computeIsSelectable(product.activeYn, product.isAgvanceLinked),
                      label: product.name,
                      value: product.productGuid,
                      getToolTip: () => blending.getProductOptionToolTip(product),
                  }))
                  .filter(
                      (product) =>
                          !ownProps.productMix.products.some(
                              (listProduct) => listProduct.productGuid === product.value
                          )
                  ),
    };
};

export const ProductBlendModal = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(injectIntl(ProductBlendModal_));
